<template>
    <div>
        <div class="flex" v-if="!wizardMode">
            <h1 class="page-header">New Client</h1>
        </div>

        <div class="mt-5 flex flex-col">
            <form>
                <div class="p-4 grid grid-cols-3 gap-6 bg-gray-100 border border-gray-300 rounded-sm shadow-md ">
                    <div class="col-span-3 flex flex-col">
                        <label class="text-base" for="name">Name</label>
                        <input v-model="client.name" type="text" class="form-input w-full">
                        <div v-if="errors.name" class="form-error">{{ errors.name[0] }}</div>
                    </div>

                    <div class="col-span-3 flex flex-col">
                        <label class="text-base" for="address">Address</label>
                        <input v-model="client.address" type="text" class="form-input w-full">
                        <div v-if="errors.address" class="form-error">{{ errors.address[0] }}</div>
                    </div>

                    <div class="flex flex-col">
                        <label class="text-base" for="city">City</label>
                        <input v-model="client.city" type="text" class="form-input">
                        <div v-if="errors.city" class="form-error">{{ errors.city[0] }}</div>
                    </div>

                    <div class="flex flex-col">
                        <label class="text-base" for="state">State</label>
                        <select v-model="client.state" class="mt-0 form-select">
                            <option value=""></option>
                            <option v-for="(state, stateIndex) in states" :key="stateIndex" :value="state.state">{{ state.state }}</option>
                        </select>
                        <div v-if="errors.state" class="form-error">{{ errors.state[0] }}</div>
                    </div>

                    <div class="flex flex-col">
                        <label class="text-base" for="postal_code">Postal Code</label>
                        <input v-model="client.postal_code" type="text" class="form-input">
                        <div v-if="errors.postal_code" class="form-error">{{ errors.postal_code[0] }}</div>
                    </div>

                    <div class="col-span-3 flex flex-col">
                        <label class="text-base" for="country">Country</label>
                        <select v-model="client.country_id" class="form-select">
                            <option value=""></option>
                            <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }}</option>
                        </select>
                        <div v-if="errors.country_id" class="form-error">{{ errors.country_id[0] }}</div>
                    </div>
                </div>
            </form>

            <button @click.prevent="save" type="button" :class="['mt-4', wizardMode ? 'btn btn-blue' : 'btn btn-green', 'self-end']">
                {{ wizardMode ? 'Continue' : 'Create Client' }}
            </button>
        </div>

        <notifications v-if="!wizardMode" classes="notification" position="bottom right"></notifications>
    </div>
</template>

<script>
    export default {
        props: {
            wizardMode: {
                type: Boolean,
                default: false
            },
            postUrl: {
                type: String,
                default: '/clients'
            }
        },
        data() {
            return {
                client: {
                    country_id: 16
                },
                errors: '',
                countries: {},
                states: {},
            }
        },

        mounted() {
            axios.get('/api/address-info').then((response) => {
                this.countries = response.data.countries;
                this.states = response.data.states;
            }).catch((error) => {
                console.log(error);
            });
        },

        methods: {
            save() {
                this.errors = '';
                axios.post(this.postUrl, this.client, {validateStatus: () => true})
                    .then(response => {
                        if (this.wizardMode) {
                            this.$emit('client-saved', response.data.client);
                        } else {
                            this.$notify({
                                type: 'success',
                                title: 'Success',
                                text: response.data.message
                            });
                            setTimeout(() => {
                                window.location = '/clients/' + response.data.client.id
                            }, 1000);
                        }
                    }).catch((error) => {
                        this.errors = error.response.data.errors;
                    });
            }
        }
    }
</script>
